// extracted by mini-css-extract-plugin
module.exports = {"container":"TableButtons_container__FqlM2","iconButton":"TableButtons_iconButton__3oQad"};